import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "../useAxios";
import { useTranslation } from "react-i18next";
import { App } from "antd";

export const useEditParticipant = () => {

    const axios = useAxios();
    const queryClient = useQueryClient();
    const {t} = useTranslation();
    const {message} = App.useApp();

    const editParticipant = async ({examTermId, participant}: {examTermId: string, participant: any}) => {
        try {
            const {data} = await axios.put(`/api/examterms/${examTermId}/participants/${participant.id}`, {
                firstName: participant.firstName,
                lastName: participant.lastName,
                email: participant.email,
            });
            return data;
        } catch (error: any) {
            const serverMessage = error?.response?.data?.Message;
            throw new Error(serverMessage || t("messages.error.editUser"));
        }
    }

    return useMutation({ mutationFn: editParticipant, onSuccess: (_, variables) => {
        queryClient.invalidateQueries({ queryKey: ["participants"] });
        queryClient.invalidateQueries({ queryKey: ["examPeriods", variables.examTermId] });
        message.success(t("messages.success.editUser"));
    }, onError: (error: Error) => {
        message.error(error.message);
    }});

}
